/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  PlanActionNotificationTriggerType,
  useSendTestPlanActionNotificationMutation,
} from "~/generated/graphql";
import { showError, showInfo } from "~/services/toast";

type Props = {
  planId: string;
  planActionId: string;
};

type SendTestParams = {
  planActionNotificationGroupId: string;
  triggerEvent: PlanActionNotificationTriggerType;
};

export function useSendTestPlanActionNotification({
  planId,
  planActionId,
}: Props) {
  const [sendTestPlanActionNotificationMutation, { loading }] =
    useSendTestPlanActionNotificationMutation({
      onCompleted: (data) => {
        if (data?.sendTestPlanActionNotification) {
          showInfo("Test notification sent.");
        }
      },
      onError: (error: Error) => showError(error.message),
    });

  async function sendTest({
    planActionNotificationGroupId,
    triggerEvent,
  }: SendTestParams) {
    if (!planId || !planActionId) {
      return;
    }

    await sendTestPlanActionNotificationMutation({
      variables: {
        input: {
          planId,
          planActionId,
          planActionNotificationGroupId,
          triggerEvent,
        },
      },
    });
  }

  return [sendTest, { loading }] as const;
}
